// File: src/miniapps/Lexgif/Lexgif.jsx

import React, { useState } from "react";
import "./Lexgif.css";

export default function Lexgif() {
  const [image, setImage] = useState(null);
  const [prompt, setPrompt] = useState("");
  const [loading, setLoading] = useState(false);
  const [gifUrl, setGifUrl] = useState(null);

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) setImage(file);
  };

  const handleGenerate = async () => {
    if (!image || !prompt) return alert("请上传图片并输入 Prompt");
    setLoading(true);

    // 模拟请求（替换成你自己的 API 调用）
    setTimeout(() => {
      // 假设生成成功
      setGifUrl("https://media.giphy.com/media/3oEjI6SIIHBdRxXI40/giphy.gif");
      setLoading(false);
    }, 2000);
  };

  return (
    <div className="lexgif-container">
      <h1>LexGIF Studio</h1>

      <div className="upload-section">
        <input type="file" accept="image/*" onChange={handleImageUpload} />
        {image && <p>✅ 已选择文件: {image.name}</p>}
      </div>

      <div className="prompt-section">
        <input
          type="text"
          placeholder="例如：把我变成跳舞的机器人"
          value={prompt}
          onChange={(e) => setPrompt(e.target.value)}
        />
      </div>

      <button onClick={handleGenerate} disabled={loading}>
        {loading ? "生成中..." : "生成 GIF"}
      </button>

      {gifUrl && (
        <div className="preview-section">
          <h3>生成预览：</h3>
          <img src={gifUrl} alt="Generated GIF" />
          <a href={gifUrl} download="lexgif.gif">下载 GIF</a>
        </div>
      )}
    </div>
  );
}
